/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function getProductChargesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getProductChargesInput(itemIds: string[], customerAccountNumber: string, quantity: number): IDataServiceRequest {
    const query = getProductChargesQuery();
    return query.createDataServiceRequestForOperation(
        'GetProductCharges',
        true,
        DataServiceEntities.GetProductChargesResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetProductChargesResponse' },
        {
            itemIds: itemIds,
            customerAccountNumber: customerAccountNumber,
            quantity: quantity
        }
    );
}

export function getProductChargesAsync(
    context: IContext,
    itemIds: string[],
    customerAccountNumber: string,
    quantity: number
): AsyncResult<DataServiceEntities.IGetProductChargesResponse> {
    const request = getProductChargesInput(itemIds, customerAccountNumber, quantity);
    return callActionOrExecute<DataServiceEntities.IGetProductChargesResponse>(request, context.callerContext);
}

// @ts-ignore
function promiseQuery(itemId?: string): DataServiceQuery {
    const key = itemId ? { itemId: itemId } : null;
    return new DataServiceQuery('Promise', 'PromiseDateEntity', DataServiceEntities.PromiseDateEntityExtensionClass, key);
}

export function createGetPromiseDateInput(
    itemids: string[],
    accountNum: number,
    catalogId: number,
    dispositionCode: string,
    quantities: number[]
): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetPromiseDate',
        true,
        DataServiceEntities.CalculatePromiseDateResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICalculatePromiseDateResponse' },
        { itemids: itemids, accountNum: accountNum, catalogId: catalogId, dispositionCode: dispositionCode, quantities: quantities }
    );
}

export function getPromiseDateAsync(
    context: IContext,
    itemids: string[],
    accountNum: number,
    catalogId: number,
    dispositionCode: string,
    quantities: number[]
): AsyncResult<DataServiceEntities.ICalculatePromiseDateResponse> {
    const request = createGetPromiseDateInput(itemids, accountNum, catalogId, dispositionCode, quantities);
    return callActionOrExecute<DataServiceEntities.ICalculatePromiseDateResponse>(request, context.callerContext);
}

export function createGetWarehouseStockAvailQtyBulkInput(itemIds: string[], userName: string, bypassCache: boolean): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetWarehouseStockAvailQtyBulk',
        true,
        DataServiceEntities.GetWarehouseStockAvailQtyBulkResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetWarehouseStockAvailQtyBulkResponse' },
        { itemIds: itemIds, userName: userName, bypassCache: bypassCache }
    );
}

export function getWarehouseStockAvailQtyBulkAsync(
    context: IContext,
    itemIds: string[],
    userName: string,
    bypassCache: boolean
): AsyncResult<DataServiceEntities.IGetWarehouseStockAvailQtyBulkResponse> {
    const request = createGetWarehouseStockAvailQtyBulkInput(itemIds, userName, bypassCache);
    return callActionOrExecute<DataServiceEntities.IGetWarehouseStockAvailQtyBulkResponse>(request, context.callerContext);
}

export function createGetStockAvailQtyInput(
    itemId: string,
    accountNum: number,
    catalogId: number,
    dispositionCode: string,
    itemQuantity: string,
    userName: string
): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetStockAvailQty',
        false,
        DataServiceEntities.GetPromiseStockAvailQtyResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetPromiseStockAvailQtyResponse' },
        {
            itemId: itemId,
            accountNum: accountNum,
            catalogId: catalogId,
            dispositionCode: dispositionCode,
            itemQuantity: itemQuantity,
            userName: userName
        }
    );
}

export function getStockAvailQtyAsync(
    context: IContext,
    itemId: string,
    accountNum: number,
    catalogId: number,
    dispositionCode: string,
    itemQuantity: string,
    userName: string
): AsyncResult<DataServiceEntities.IGetPromiseStockAvailQtyResponse> {
    const request = createGetStockAvailQtyInput(itemId, accountNum, catalogId, dispositionCode, itemQuantity, userName);
    return callActionOrExecute<DataServiceEntities.IGetPromiseStockAvailQtyResponse>(request, context.callerContext);
}

export function createGetWarehouseStockAvailQtyInput(
    itemId: string,
    accountNum: number,
    itemQuantity: string,
    userName: string
): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetWarehouseStockAvailQty',
        false,
        DataServiceEntities.GetWarehouseStockAvailQtyResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetWarehouseStockAvailQtyResponse' },
        { itemId: itemId, accountNum: accountNum, itemQuantity: itemQuantity, userName: userName }
    );
}

export function getWarehouseStockAvailQtyAsync(
    context: IContext,
    itemId: string,
    accountNum: number,
    itemQuantity: string,
    userName: string
): AsyncResult<DataServiceEntities.IGetWarehouseStockAvailQtyResponse> {
    const request = createGetWarehouseStockAvailQtyInput(itemId, accountNum, itemQuantity, userName);
    return callActionOrExecute<DataServiceEntities.IGetWarehouseStockAvailQtyResponse>(request, context.callerContext);
}

export function createGetStockAvailDateInput(
    itemId: string,
    qty: number,
    accountNum: number,
    catalogId: number,
    dispositionCode: string
): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetStockAvailDate',
        false,
        DataServiceEntities.CalculateStockAvailDateResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICalculateStockAvailDateResponse' },
        { itemId: itemId, qty: qty, accountNum: accountNum, catalogId: catalogId, dispositionCode: dispositionCode }
    );
}

export function getStockAvailDateAsync(
    context: IContext,
    itemId: string,
    qty: number,
    accountNum: number,
    catalogId: number,
    dispositionCode: string
): AsyncResult<DataServiceEntities.ICalculateStockAvailDateResponse> {
    const request = createGetStockAvailDateInput(itemId, qty, accountNum, catalogId, dispositionCode);
    return callActionOrExecute<DataServiceEntities.ICalculateStockAvailDateResponse>(request, context.callerContext);
}

export function createGetStockAvailDateJsonInput(
    itemId: string,
    qty: number,
    accountNum: number,
    catalogId: number,
    dispositionCode: string,
    userName: string
): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetStockAvailDateJson',
        false,
        DataServiceEntities.CalculateStockAvailDateJsonResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICalculateStockAvailDateJsonResponse' },
        { itemId: itemId, qty: qty, accountNum: accountNum, catalogId: catalogId, dispositionCode: dispositionCode, userName: userName }
    );
}

export function getStockAvailDateJsonAsync(
    context: IContext,
    itemId: string,
    qty: number,
    accountNum: number,
    catalogId: number,
    dispositionCode: string,
    userName: string
): AsyncResult<DataServiceEntities.ICalculateStockAvailDateJsonResponse> {
    const request = createGetStockAvailDateJsonInput(itemId, qty, accountNum, catalogId, dispositionCode, userName);
    return callActionOrExecute<DataServiceEntities.ICalculateStockAvailDateJsonResponse>(request, context.callerContext);
}

export function createGetOrderPoNumberInput(orderId: string): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrderPoNumber',
        false,
        DataServiceEntities.GetOrderPoNumberResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetOrderPoNumberResponse' },
        { orderId: orderId }
    );
}

export function getOrderPoNumberAsync(context: IContext, orderId: string): AsyncResult<DataServiceEntities.IGetOrderPoNumberResponse> {
    const request = createGetOrderPoNumberInput(orderId);
    return callActionOrExecute<DataServiceEntities.IGetOrderPoNumberResponse>(request, context.callerContext);
}

export function createGetOrderPurchaseNoteInput(orderId: string): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrderPurchaseNote',
        false,
        DataServiceEntities.GetOrderPurchaseNoteResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetOrderPurchaseNoteResponse' },
        { orderId: orderId }
    );
}

export function getOrderPurchaseNoteAsync(
    context: IContext,
    orderId: string
): AsyncResult<DataServiceEntities.IGetOrderPurchaseNoteResponse> {
    const request = createGetOrderPurchaseNoteInput(orderId);
    return callActionOrExecute<DataServiceEntities.IGetOrderPurchaseNoteResponse>(request, context.callerContext);
}

export function createGetClientDefaultTransportInput(accountNum: number): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetClientDefaultTransport',
        false,
        DataServiceEntities.GetClientDefaultTransportResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetClientDefaultTransportResponse' },
        { accountNum: accountNum }
    );
}

export function getClientDefaultTransportAsync(
    context: IContext,
    accountNum: number
): AsyncResult<DataServiceEntities.IGetClientDefaultTransportResponse> {
    const request = createGetClientDefaultTransportInput(accountNum);
    return callActionOrExecute<DataServiceEntities.IGetClientDefaultTransportResponse>(request, context.callerContext);
}

export function createGetItemBoaManufacturingSiteInput(itemId: string): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetItemBoaManufacturingSite',
        false,
        DataServiceEntities.GetItemBoaManufacturingSiteResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetItemBoaManufacturingSiteResponse' },
        { itemId: itemId }
    );
}

export function getItemBoaManufacturingSiteAsync(
    context: IContext,
    itemId: string
): AsyncResult<DataServiceEntities.IGetItemBoaManufacturingSiteResponse> {
    const request = createGetItemBoaManufacturingSiteInput(itemId);
    return callActionOrExecute<DataServiceEntities.IGetItemBoaManufacturingSiteResponse>(request, context.callerContext);
}

// @ts-ignore
function userLevelsQuery(userId?: string): DataServiceQuery {
    const key = userId ? { UserId: userId } : null;
    return new DataServiceQuery('UserLevels', 'UserLevelEntity', DataServiceEntities.UserLevelEntityExtensionClass, key);
}

export function createGetUserLevelByUserIdInput(userId: string): IDataServiceRequest {
    const query = userLevelsQuery();
    return query.createDataServiceRequestForOperation(
        'GetUserLevelByUserId',
        false,
        DataServiceEntities.GetUserLevelByExternalIdResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetUserLevelByExternalIdResponse' },
        { userId: userId }
    );
}

export function getUserLevelByUserIdAsync(
    context: IContext,
    userId: string
): AsyncResult<DataServiceEntities.IGetUserLevelByExternalIdResponse> {
    const request = createGetUserLevelByUserIdInput(userId);
    return callActionOrExecute<DataServiceEntities.IGetUserLevelByExternalIdResponse>(request, context.callerContext);
}

export function createGetNomenclatureBundleDetailsInput(itemId: string, qty: number): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetNomenclatureBundleDetails',
        false,
        DataServiceEntities.GetNomenclatureBundleDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetNomenclatureBundleDetailsResponse' },
        { itemId: itemId, qty: qty }
    );
}

export function getNomenclatureBundleDetailsAsync(
    context: IContext,
    itemId: string,
    qty: number
): AsyncResult<DataServiceEntities.IGetNomenclatureBundleDetailsResponse> {
    const request = createGetNomenclatureBundleDetailsInput(itemId, qty);
    return callActionOrExecute<DataServiceEntities.IGetNomenclatureBundleDetailsResponse>(request, context.callerContext);
}

export function createGetClientDefaultDeliveryAddressInput(accountNum: string): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetClientDefaultDeliveryAddress',
        false,
        DataServiceEntities.GetClientDefaultDeliveryAddressResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetClientDefaultDeliveryAddressResponse' },
        { accountNum: accountNum }
    );
}

export function getClientDefaultDeliveryAddressAsync(
    context: IContext,
    accountNum: string
): AsyncResult<DataServiceEntities.IGetClientDefaultDeliveryAddressResponse> {
    const request = createGetClientDefaultDeliveryAddressInput(accountNum);
    return callActionOrExecute<DataServiceEntities.IGetClientDefaultDeliveryAddressResponse>(request, context.callerContext);
}

export function createGetDocumentDownloadUrlInput(documentType: string, documentId: string): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetDocumentDownloadUrl',
        false,
        DataServiceEntities.GetDocumentDownloadUrlResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetDocumentDownloadUrlResponse' },
        { documentType: documentType, documentId: documentId }
    );
}

export function getDocumentDownloadUrlAsync(
    context: IContext,
    documentType: string,
    documentId: string
): AsyncResult<DataServiceEntities.IGetDocumentDownloadUrlResponse> {
    const request = createGetDocumentDownloadUrlInput(documentType, documentId);
    return callActionOrExecute<DataServiceEntities.IGetDocumentDownloadUrlResponse>(request, context.callerContext);
}

export function createGetDocumentAvailabilityInput(documentType: string, documentId: string): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'GetDocumentAvailability',
        false,
        DataServiceEntities.GetDocumentAvailabilityResponseExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetDocumentAvailabilityResponse' },
        { documentType: documentType, documentId: documentId }
    );
}

export function getDocumentAvailabilityAsync(
    context: IContext,
    documentType: string,
    documentId: string
): AsyncResult<DataServiceEntities.IGetDocumentAvailabilityResponse> {
    const request = createGetDocumentAvailabilityInput(documentType, documentId);
    return callActionOrExecute<DataServiceEntities.IGetDocumentAvailabilityResponse>(request, context.callerContext);
}

export function createCheckEmailOrderConfirmationRoleInput(accountNum: number, email: string): IDataServiceRequest {
    const query = promiseQuery();
    return query.createDataServiceRequestForOperation(
        'CheckEmailOrderConfirmationRole',
        false,
        DataServiceEntities.CheckEmailOrderConfirmationRoleResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICheckEmailOrderConfirmationRoleResponse' },
        { accountNum: accountNum, email: email }
    );
}

export function checkEmailOrderConfirmationRoleAsync(
    context: IContext,
    accountNum: number,
    email: string
): AsyncResult<DataServiceEntities.ICheckEmailOrderConfirmationRoleResponse> {
    const request = createCheckEmailOrderConfirmationRoleInput(accountNum, email);
    return callActionOrExecute<DataServiceEntities.ICheckEmailOrderConfirmationRoleResponse>(request, context.callerContext);
}

function boaSearchInvoicesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function boaSearchInvoicesInput(
    searchTerm: string,
    customerAccountNumber: string,
    businessPartnerId: string,
    maxResults: number
): IDataServiceRequest {
    const query = boaSearchInvoicesQuery();
    return query.createDataServiceRequestForOperation(
        'BoaSearchInvoices',
        true,
        DataServiceEntities.BoaSearchInvoicesResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IBoaSearchInvoicesResponse' },
        {
            searchTerm: searchTerm,
            customerAccountNumber: customerAccountNumber,
            businessPartnerId: businessPartnerId,
            maxResults: maxResults
        }
    );
}

export function boaSearchInvoicesAsync(
    context: IContext,
    searchTerm: string,
    customerAccountNumber: string,
    businessPartnerId: string,
    maxResults: number
): AsyncResult<DataServiceEntities.IBoaSearchInvoicesResponse> {
    const request = boaSearchInvoicesInput(searchTerm, customerAccountNumber, businessPartnerId, maxResults);
    return callActionOrExecute<DataServiceEntities.IBoaSearchInvoicesResponse>(request, context.callerContext);
}

function boaGetInvoiceLinesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function boaGetInvoiceLinesInput(
    customerAccountNumber: string,
    businessPartnerId: string,
    paidStatus: number,
    skip: number,
    top: number,
    invoiceIds: string[]
): IDataServiceRequest {
    const query = boaGetInvoiceLinesQuery();
    return query.createDataServiceRequestForOperation(
        'BoaGetInvoiceLines',
        true,
        DataServiceEntities.BoaGetInvoiceLinesResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IBoaGetInvoiceLinesResponse' },
        {
            customerAccountNumber: customerAccountNumber,
            businessPartnerId: businessPartnerId,
            paidStatus: paidStatus,
            skip: skip,
            top: top,
            invoiceIds: invoiceIds
        }
    );
}

export function boaGetInvoiceLinesAsync(
    context: IContext,
    customerAccountNumber: string,
    businessPartnerId: string,
    paidStatus: number,
    skip: number,
    top: number,
    invoiceIds: string[]
): AsyncResult<DataServiceEntities.IBoaGetInvoiceLinesResponse> {
    const request = boaGetInvoiceLinesInput(customerAccountNumber, businessPartnerId, paidStatus, skip, top, invoiceIds);
    return callActionOrExecute<DataServiceEntities.IBoaGetInvoiceLinesResponse>(request, context.callerContext);
}
